"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentReadEventType = exports.ContentReadContentType = void 0;
const t = __importStar(require("io-ts"));
var ContentReadSourceEnum;
(function (ContentReadSourceEnum) {
    ContentReadSourceEnum["INLINE"] = "INLINE";
    ContentReadSourceEnum["SEARCH"] = "SEARCH";
    ContentReadSourceEnum["NAVIGATION"] = "NAVIGATION";
    ContentReadSourceEnum["AUTOMATION"] = "AUTOMATION";
    ContentReadSourceEnum["FEEDBACK_HISTORY"] = "FEEDBACK_HISTORY";
    ContentReadSourceEnum["FEEDBACK_NOTIFICATION"] = "FEEDBACK_NOTIFICATION";
    ContentReadSourceEnum["FEEDBACK_CARD"] = "FEEDBACK_CARD";
    ContentReadSourceEnum["COMMENT_NOTIFICATION"] = "COMMENT_NOTIFICATION";
    ContentReadSourceEnum["FAVORITES"] = "FAVORITES";
})(ContentReadSourceEnum || (ContentReadSourceEnum = {}));
exports.ContentReadContentType = t.intersection([
    t.type({
        id: t.string,
    }),
    t.partial({
        path: t.array(t.union([t.string, t.null, t.undefined])),
        labels: t.array(t.string),
        knowledgeId: t.string,
        knowledge: t.string,
        type: t.string,
        childrenOrder: t.array(t.type({ id: t.string, entityType: t.string })),
        caseParameters: t.array(t.string),
        location: t.string,
        isOutdated: t.boolean,
        actions: t.array(
        // chrome_ext + zendesk_app
        t.type({
            id: t.string,
            payload: t.unknown,
        })),
        parameters: t.record(t.union([t.string, t.null, t.undefined]), t.union([t.string, t.array(t.string), t.null, t.undefined])),
        published: t.boolean,
        isLastStep: t.boolean,
        isPublic: t.boolean,
    }),
]);
exports.ContentReadEventType = t.intersection([
    t.type({
        content: exports.ContentReadContentType,
    }),
    t.partial({
        deepLoading: t.boolean,
        source: t.string,
        location: t.string,
        lang: t.string,
    }),
]);
